import {Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {A11yModule} from '@angular/cdk/a11y';
import {buscarFuncoesMenuV2, FuncaoMenuV2} from './menu-v2.catalogo';
import {UsoMenuV2} from './menu-v2.uso';

/**
 * Diálogo "Buscar função" (Ctrl K / ⌘ K) compartilhado pelo menu-v2 e pelo menu antigo.
 * Quem hospeda decide o que fazer com a função escolhida em `onExecutar`.
 */
@Component({
  selector: 'app-menu-busca',
  standalone: true,
  imports: [CommonModule, FormsModule, A11yModule],
  templateUrl: './menu-busca.component.html',
  styleUrls: ['./menu-busca.component.scss']
})
export class MenuBuscaComponent implements OnChanges {
  @Input() funcoes: FuncaoMenuV2[] = [];
  @Input() uso: UsoMenuV2 | null = null;
  /** Emitido antes de abrir, para o hospedeiro atualizar `funcoes` e fechar seus painéis. */
  @Output() onAbrir = new EventEmitter<void>();
  @Output() onExecutar = new EventEmitter<FuncaoMenuV2>();
  @ViewChild('resultadosBusca') resultadosBusca?: ElementRef<HTMLElement>;
  aberta = false;
  busca = '';
  resultados: FuncaoMenuV2[] = [];
  resultadoAtivo = 0;
  readonly atalho = /Mac|iPhone|iPad/.test(navigator.platform) ? '⌘ K' : 'Ctrl K';
  private focoAnterior: HTMLElement | null = null;

  ngOnChanges(): void { if (this.aberta) this.atualizar(); }

  abrir(): void {
    this.onAbrir.emit();
    this.focoAnterior = document.activeElement as HTMLElement;
    this.busca = '';
    this.atualizar();
    this.aberta = true;
  }

  fechar(): void {
    if (!this.aberta) return;
    this.aberta = false;
    this.focoAnterior?.focus();
  }

  atualizar(): void {
    this.resultados = buscarFuncoesMenuV2(this.funcoes, this.busca, id => this.uso?.pontuacao(id) || 0);
    this.resultadoAtivo = 0;
  }

  teclas(event: KeyboardEvent): void {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!this.resultados.length) return;
      const passo = event.key === 'ArrowDown' ? 1 : -1;
      this.resultadoAtivo = (this.resultadoAtivo + passo + this.resultados.length) % this.resultados.length;
      this.resultadosBusca?.nativeElement.children[this.resultadoAtivo]?.scrollIntoView({block: 'nearest'});
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      const item = this.resultados[this.resultadoAtivo];
      if (item) this.executar(item);
    }
  }

  executar(item: FuncaoMenuV2): void {
    this.fechar();
    this.onExecutar.emit(item);
  }

  @HostListener('document:keydown', ['$event']) atalhoTeclado(event: KeyboardEvent): void {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      if (!this.aberta) this.abrir();
    } else if (event.key === 'Escape' && this.aberta) {
      event.preventDefault();
      this.fechar();
    }
  }
}
